<div class="notification-container">
  <div class="notification-header">
    <div class="title h2">Notifications</div>
    <div class="actions">
      <ng-button
        variant="icon"
        (click)="notificationClose.emit()"
        icon="icon-close"
      />
    </div>
  </div>
  <fc-tab-group [fc-stretch-tabs]="false">
    <fc-tab label="Events">
      <ng-template fc-tab-label>Events</ng-template>
      <fc-events-tab></fc-events-tab>
    </fc-tab>
    <fc-tab label="News">
      <ng-template fc-tab-label>News</ng-template>
      <fc-news-tab></fc-news-tab>
    </fc-tab>
  </fc-tab-group>
</div>

<div class="overlay" (click)="notificationClose.emit()"></div>
